class DynamicVideoTestimonials extends HTMLElement {
  connectedCallback() {
    this.onClick = this.handleClick.bind(this);
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  handleClick(event) {
    const trigger = event.target.closest('[data-vt-play]');
    if (!trigger) return;

    const facade = trigger.closest('[data-vt-facade]');
    if (!facade || facade.hasAttribute('data-vt-active')) return;

    const embed = facade.dataset.vtEmbed;
    if (!embed) return;

    const iframe = document.createElement('iframe');
    iframe.className = 'video-testimonials__iframe';
    iframe.src = embed;
    iframe.title = trigger.getAttribute('aria-label') || 'Video';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    facade.setAttribute('data-vt-active', '');
    facade.replaceChildren(iframe);
    iframe.focus();
  }
}

if (!customElements.get('dynamic-video-testimonials')) {
  customElements.define('dynamic-video-testimonials', DynamicVideoTestimonials);
}
